import { Navigate, useLocation, useParams } from "react-router-dom";
import { Loading } from "@/components/atoms";
import { useOperator, useOperatorAccess } from "@/hooks";
import { useAppSelector } from "@/redux/hooks";
import { selectIsOnboardingComplete } from "@/redux/slices/quickSetup";

export const Home = () => {
  const operator = useOperator();
  const { operatorId } = useParams();
  const location = useLocation();
  const isOnboardingComplete = useAppSelector(selectIsOnboardingComplete);
  const { isAdmin, isUnsubscribed, isSolo, isLoading: isLoadingAccess } = useOperatorAccess();

  const currentOperatorId = operatorId || operator.id;
  const isAlreadyInOperatorPath = location.pathname.includes(`/operator/${currentOperatorId}`);

  if (!isAdmin) {
    const path = isAlreadyInOperatorPath ? "bookings" : `operator/${currentOperatorId}/bookings`;
    return <Navigate to={path} />;
  }

  // Wait for subscription state before deciding where to land an admin.
  if (isOnboardingComplete === null || isLoadingAccess) {
    return <Loading />;
  }

  let destination: string;
  if (isUnsubscribed) {
    // Inactive account → lock pane (banner + reduced menu handled by layout).
    destination = "subscription-required";
  } else if (!isSolo && isOnboardingComplete) {
    // Solo operators manage day-to-day in the Driver App, so they keep landing on Quick Setup even
    // once it is finished; everyone else moves on to Bookings.
    destination = "bookings";
  } else {
    destination = "quick-setup";
  }
  const path = isAlreadyInOperatorPath ? destination : `operator/${currentOperatorId}/${destination}`;

  return <Navigate to={path} />;
};
